import { memo } from "react"
import "./Navbar.css";
import Logo from "./../../assets/logowhite.png";
import { Button } from "../../components";
import { Link, useNavigate, NavLink } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectLikedLodges,
} from "../../features/slices/lodgeSlice";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { logoutUser, selectUser } from "../../features/slices/userSlice";

const Navbar = ({ marketplace }) => {
  const dispatch = useDispatch();
  const getUser = useSelector(selectUser);
  const navigate = useNavigate();
  const [openNav, setOpenNav] = useState(false);

  const likedLodges = useSelector(selectLikedLodges);

  const handleLikedPage = () => {
    navigate("/liked-lodges");
  };

  const handleLogout = () => {
    dispatch(logoutUser());
  };

  const activeStyling = ({ isActive }) =>
    isActive ? { color: "#44c570" } : { color: "#0a0d14" };

  return (
    <>
      <nav className="nav">
        <div className="container">
          <div className="nav__content">
            <Link to="/" className="nav__logo-container">
              <img loading="lazy" src={Logo} className="nav__logo" alt="nav-logo" />
            </Link>

            <ul className="nav__links">
              {/* <li className="nav__link">Town</li> */}
              {marketplace && (
                <AnchorLink href="#market-place">
                  <li className="nav__link">Marketplace</li>
                </AnchorLink>
              )}
              <li className="nav__link">
                <NavLink
                  className={"NAVLINK"}
                  style={activeStyling}
                  to="/liked-lodges"
                >
                  <span>Liked</span>
                  <span className="liked-notification">
                    {likedLodges?.length || 0}
                  </span>
                </NavLink>
              </li>

              <li className="nav__link">
                <NavLink
                  className={"NAVLINK"}
                  style={activeStyling}
                  to="/verify-property"
                >
                  Suggested
                </NavLink>
              </li>

              {Object.keys(getUser).length === 0 ? (
                <li className="nav__link">
                  <NavLink style={activeStyling} to="/auth">
                    Login
                  </NavLink>
                </li>
              ) : (
                <li onClick={handleLogout} className="nav__link">
                  <NavLink style={activeStyling} to="/auth">
                    Logout
                  </NavLink>
                </li>
              )}

              {/* <li className="nav__link">
                <NavLink style={activeStyling} to="/our-team">
                  Our Team
                </NavLink>
              </li> */}

              {getUser?.role === "admin" ? (
                <>
                  {" "}
                  <Link to="/create-lodge">
                    <Button text="Create a Lodge" type="outline-blue" />
                  </Link>
                  <Link to="/view-all">
                    <Button text="Filter all properties" type="outline" />
                  </Link>
                  {/* <Link to="/verify-property">
                    <Button text="View Suggested" type="outline" />
                  </Link> */}
                </>
              ) : (
                <>
                  <Link to="/suggest">
                    <Button text="Suggest a lodge" type="fill" />
                  </Link>
                  <Link to="/view-all">
                    <Button text="Filter all properties" type="outline" />
                  </Link>

                  {/* <Link to="/verify-property">
                    <Button text="View Suggested" type="outline" />
                  </Link> */}
                </>
              )}
            </ul>

            {openNav ? (
              <HighlightOffIcon
                onClick={() => setOpenNav(false)}
                className="nav__mobile-close"
              />
            ) : (
              <MenuIcon
                onClick={() => setOpenNav(true)}
                className="nav__mobile-menu"
              />
            )}
          </div>
        </div>
        <ul className={`mobile__nav ${openNav && "active"}`}>
          {/* <li className="nav__link">Town</li> */}
          {marketplace && (
            <AnchorLink href="#market-place">
              <li className="nav__link">Marketplace</li>
            </AnchorLink>
          )}

          <li className="nav__link">
            <NavLink
              className={"NAVLINK"}
              style={activeStyling}
              to="/liked-lodges"
            >
              <span>Liked</span>
              <div className="liked-notification">{likedLodges?.length}</div>
            </NavLink>
          </li>
          <li className="nav__link">
            <NavLink
              className={"NAVLINK"}
              style={activeStyling}
              to="/verify-property"
            >
              Suggested
            </NavLink>
          </li>
          {Object.keys(getUser).length === 0 ? (
            <li className="nav__link">
              <NavLink style={activeStyling} to="/auth">
                Login
              </NavLink>
            </li>
          ) : (
            <li onClick={handleLogout} className="nav__link">
              <NavLink style={activeStyling} to="/auth">
                Logout
              </NavLink>
            </li>
          )}

          {/* <li className="nav__link">
            <NavLink style={activeStyling} to="/our-team">
              Our Team
            </NavLink>
          </li> */}

          {getUser?.role === "admin" ? (
            <>
              {" "}
              <Link to="/create-lodge">
                <Button text="Create a Lodge" type="outline-blue" />
              </Link>
              <Link to="/view-all">
                <Button text="Filter all properties" type="outline" />
              </Link>
            </>
          ) : (
            <>
              <Link to="/suggest">
                <Button text="Suggest a lodge" type="fill" />
              </Link>
              <Link to="/view-all">
                <Button text="Filter all properties" type="outline" />
              </Link>

              {/* <Link to="/verify-property">
                <Button text="View Suggested" type="outline" />
              </Link> */}
            </>
          )}
        </ul>
      </nav>
    </>
  );
};

export default memo(Navbar);
